<template>
  <div >
    <h4>{{ title }}</h4>
    <v-chart :forceFit="true" :height="height" :data="dataSource" :scale="scale" >
      <v-tooltip/>
      <v-axis/>
      <v-legend />
      <v-stack-bar position="name*value" :opacity="1" color="type"/>
    </v-chart>
  </div>
</template>

<script>
  import { triggerWindowResizeEvent } from '@/utils/util'

  export default {
    name: 'Bar',
    props: {
     dataSource: {
        type: Array,
        required: true
      },
      yaxisText: {
        type: String,
        default: 'y'
      },
      title: {
        type: String,
        default: ''
      },
      height: {
        type: Number,
        default: 400
      }
    },
    data() {
      return {
        padding: ['auto', 'auto', '40', '50'] ,
        color : ['type', ['#40a9ff', '#1890ff', '#096dd9', '#0050b3']]

      /*const scale = [{
        dataKey: 'value',
        alias: '占比（%）',
        max: 100,
        min: 0,
        nice: true
      }
        ]*/
      }
    },
    computed: {
      scale() {
        return [{
          dataKey: 'value',
         // alias: this.yaxisText
        }]
      }
    },
    mounted() {
      triggerWindowResizeEvent()
    }
  }
</script>